<div class="MainContainer">

<div class="ETransportStepOneContainer animated fadeInDown" *ngIf="ShowETransportStepOne">
  <div class="ETransportStepOneTitle">
    <p>{{'GenerateUITTitle' | translate}} [{{this.UITShippingCompany?.Name}}]</p>
    <i class="material-icons" (click)="ShowETransportStepOne = false;">close</i>
  </div>
  <div class="ETransportStepOneBody">
    <div class="ETransportStepOneBodyRow">
      <div class="PopUpBodyOneThirddContainer">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'ETransportCustomsStation' | translate }}</mat-label>
           <mat-select name="ETransportCustomsStation" [compareWith]="compareFn" [(ngModel)]="ETransportCustomsStation">
            <mat-option *ngFor="let a of this.CustomsStations;" [value]="a">
               {{a.Name}}
             </mat-option>
           </mat-select>
          </mat-form-field>
        </div>
         
        <div class="PopUpBodyTwoThirdsContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'ETransportDocumentType' | translate }}</mat-label>
             <mat-select name="ETransportDocumentType" [compareWith]="compareFn" [(ngModel)]="ETransportDocumentType">
              <mat-option *ngFor="let a of this.ETransportDocumentTypes;" [value]="a">
                 {{a.Name}}
               </mat-option>
             </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="ETransportStepOneBodyRow">
      <div class="PopUpBodyOneThirddContainer">
        <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
          <mat-label>{{ 'ETransportMeasuringUnit' | translate }}</mat-label>
           <mat-select name="ETransportMeasuringUnit" [compareWith]="compareFn" [(ngModel)]="ETransportMeasuringUnit">
            <mat-option *ngFor="let a of this.ETransportMeasuringUnits;" [value]="a">
               {{a.Name}}
             </mat-option>
           </mat-select>
          </mat-form-field>
        </div>
         
        <div class="PopUpBodyTwoThirdsContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'ETransportOperationReason' | translate }}</mat-label>
             <mat-select name="ETransportOperationReason" [compareWith]="compareFn" [(ngModel)]="ETransportOperationReason">
              <mat-option *ngFor="let a of this.ETransportOperationReasons;" [value]="a">
                 {{a.Name}}
               </mat-option>
             </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="ETransportStepOneBodyRow">
      <div class="PopUpBodyOneThirddContainer">
        <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
          <mat-label>{{ 'AutoPlatesNumber' | translate }}</mat-label>
          <input matInput placeholder="{{ 'AutoPlatesNumber' | translate }}" autocomplete="off" [(ngModel)]="UITAutoPlatesNumber">
        </mat-form-field>
      </div>
         
        <div class="PopUpBodyTwoThirdsContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'ETransportOperationType' | translate }}</mat-label>
             <mat-select name="ETransportOperationType" [compareWith]="compareFn" [(ngModel)]="ETransportOperationType">
              <mat-option *ngFor="let a of this.ETransportOperationTypes;" [value]="a">
                 [{{a.Name}}] {{a.Description}}
               </mat-option>
             </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="ETransportStepOneBodyRow">
      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: 95%;">
        <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
         <mat-select name="ETransportOperationType" [compareWith]="compareFn" [(ngModel)]="UITShippingCompany">
          <mat-option *ngFor="let s of this.ShippingCompanies;" [value]="s">
             {{s.Name}}
           </mat-option>
         </mat-select>
        </mat-form-field>
    </div>

    <div class="ETransportStepOneBodyRow" *ngIf="this.ETransportOperationType.ID == 40 || this.ETransportOperationType.ID == 50">
      <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: 95%;">
        <mat-label>{{ 'ETransportCustomsBureau' | translate }}</mat-label>
         <mat-select name="ETransportCustomsBureau" [compareWith]="compareFn" [(ngModel)]="ETransportCustomsBureau">
          <mat-option *ngFor="let s of this.ETransportCustomsBureaus;" [value]="s">
             {{s.Name}}
           </mat-option>
         </mat-select>
        </mat-form-field>
    </div>
    
  </div>
  <div class="ETransportStepOneCommands">
    <button mat-raised-button color="accent" class="FilterButtonAction" (click)="UploadETransportInvoice(this.CurrentInvoice);">{{ 'GenerateUIT' | translate }}</button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowRecallibrateProfitsSTPFinal">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowRecallibrateProfitsSTPFinal = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'RecallibrateProfitsSTP' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'RecallibrateProfitsSTPDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowRecallibrateProfitsSTPFinal = false; ShowSellthroughPartnerProfitsRecallibration = true;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.loading" mat-raised-button color="primary" class="InfoQuestionButton PrimaryButtonTheme" (click)="ShowRecallibrateProfitsSTPFinal = false;RecallibrateProfitsSTP();">
        <i class="material-icons">check</i>
        {{ 'RecallibrateProfitsSTP' | translate }}
      </button>
    </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowPreAskClientBalanceAllocation">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowPreAskClientBalanceAllocation = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'PreAskClientBalanceAllocation' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'PreAskClientBalanceAllocationDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowPreAskClientBalanceAllocation = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.loading" mat-raised-button color="primary" class="InfoQuestionButton PrimaryButtonTheme" (click)="ShowPreAskClientBalanceAllocation = false; AutoAllocateClientBalance();">
      <i class="material-icons">lock_reset</i>
      {{ 'AllocateBalance' | translate }}
    </button>
  </div>
</div>

<div class="InfoQuestion animated fadeInDown" *ngIf="ShowResetEFactura">
  <div class="InfoQuestionClose">
    <i class="material-icons" (click)="ShowResetEFactura = false;">close</i>
  </div>
  <div class="InfoQuestionTitle">
    {{ 'ResetEFacturaStatus' | translate }}
  </div>
  <div class="InfoQuestionBody">
    {{ 'ResetEFacturaStatusDescription' | translate }}
  </div>

  <div class="InfoQuestionCommands">
    <button [disabled]="this.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowResetEFactura = false; ShowSellthroughPartnerProfitsRecallibration = true;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
    <button [disabled]="this.loading" mat-raised-button color="primary" class="InfoQuestionButton PrimaryButtonTheme" (click)="ShowResetEFactura = false;ResetEFacturaStatus(this.CurrentInvoice);">
      <i class="material-icons">lock_reset</i>
      {{ 'ResetEFacturaStatus' | translate }}
    </button>
  </div>
</div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowForceStatusContainer">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowForceStatusContainer = false; CurrentInvoice = null;">close</i>
    </div>
    <div class="InfoQuestionTitle" *ngIf="this.CurrentInvoice.Details.ForceDocumentClosing != true;">
      {{ 'ForceDocumentClosing' | translate }}
    </div>
    <div class="InfoQuestionBody" *ngIf="this.CurrentInvoice.Details.ForceDocumentClosing != true;">
      {{ 'ForceDocumentClosingDesc' | translate }}
    </div>

    <div class="InfoQuestionTitle" *ngIf="this.CurrentInvoice.Details.ForceDocumentClosing == true;">
      {{ 'DeForceDocumentClosing' | translate }}
    </div>
    <div class="InfoQuestionBody" *ngIf="this.CurrentInvoice.Details.ForceDocumentClosing == true;">
      {{ 'DeForceDocumentClosingDesc' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowForceStatusContainer = false; CurrentInvoice = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" style="background: #0082e6;" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowForceStatusContainer = false;ForceDocumentClosing(CurrentInvoice);">{{ 'Yes' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowObservationDetailContainer">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowObservationDetailContainer = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
     {{'ObservationDetailContainerTitle' | translate}}
    </div>
    <div class="InfoQuestionBody" style="padding-right: 5%;">
      <mat-form-field appearance="outline" class="ObservationDetailTextArea">
        <mat-label>{{ 'Receptions.Mentions' | translate }}</mat-label>
        <textarea autocomplete="off" matInput
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="5"
                  cdkAutosizeMaxRows="10"
                  [(ngModel)]="CurrentInvoice.Details.Observations"></textarea>
      </mat-form-field>
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" color="primary" mat-raised-button class="InfoQuestionButton" (click)="UpdateInvoiceObservations(this.CurrentInvoice.Details.ID, this.CurrentInvoice.Details.Observations);">
        {{ 'Update' | translate }}
      </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteShippingDetailsContainer">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteShippingDetailsContainer = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'DeleteShippingDetails' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteShippingDetailsContainer = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteShippingDetailsContainer = false;DeleteShippingDetails(this.CurrentInvoice.Details.ShippingDetails);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteBoxQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false; CurrentBox = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteBoxQuestion = false;DeleteBox(CurrentBox);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowOriginalCurrencyError">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowOriginalCurrencyError = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
     {{'ShowOriginalCurrencyError' | translate}}
    </div>
    <div class="InfoQuestionBody">
      {{'ShowOriginalCurrencyErrorDesc' | translate}}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" color="warn" mat-raised-button class="InfoQuestionButton" (click)="ShowOriginalCurrencyError = false;">
        {{ 'OK' | translate }}
      </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowMustSelectSinglePartnerError">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowMustSelectSinglePartnerError = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
     {{'ShowMustSelectSinglePartnerError' | translate}}
    </div>
    <div class="InfoQuestionBody">
      {{'ShowMustSelectSinglePartnerErrorDesc' | translate}}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" color="warn" mat-raised-button class="InfoQuestionButton" (click)="ShowMustSelectSinglePartnerError = false;">
        {{ 'OK' | translate }}
      </button>
    </div>
  </div>

  <div class="ShippingDetailsContainer animated fadeInDown" *ngIf="ShowShippingDetailsContainer == true;">
    <div class="ShippingDetailsContainerCloseIcon">
      <i class="material-icons" (click)="ShowShippingDetailsContainer = false;">close</i>
    </div>

    <div class="ShippingDetailsContainerTitle">{{'ShippingDetails' | translate}}</div>

    <div class="ShippingDetailsContainerBody">

      <p class="ShippingDetailsContainerBodyTitle">
        {{'GeneralShippingInformation' | translate}}
        <img *ngIf="this.CurrentInvoice.Details.ShippingDetails?.ShippingCompany?.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.ShippingDetails.ShippingCompany.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
      </p>

      <mat-form-field style="width: 100%;" appearance="outline">
        <mat-label>{{ 'ShippingServiceType' | translate }}</mat-label>
        <mat-select name="ShippingServiceType" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.ShippingServiceType">
          <mat-option *ngFor="let s of this.ShippingServiceTypes" [value]="s">
            {{s.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%;" appearance="outline">
        <mat-label>{{ 'ShippingWay' | translate }}</mat-label>
        <mat-select name="ShippingWay" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.ShippingWay">
          <mat-option *ngFor="let s of this.ShippingWays" [value]="s">
            {{s.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%;" appearance="outline">
        <mat-label>{{ 'ShippingResponsability' | translate }}</mat-label>
        <mat-select name="ShippingResponsability" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.ShippingResponsability">
          <mat-option *ngFor="let s of this.ShippingResponsabilities" [value]="s">
            {{s.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%;" appearance="outline">
        <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
        <mat-select name="ShippingCompany" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.ShippingCompany">
          <mat-option *ngFor="let s of this.ShippingCompanies" [value]="s">
            {{s.Name}}
            <img *ngIf="s.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + s.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%;" appearance="outline">
        <mat-label>{{ 'WeightType' | translate }}</mat-label>
        <mat-select name="WeightType" [compareWith]="compareFn" [(ngModel)]="this.CurrentInvoice.Details.ShippingDetails.WeightType">
          <mat-option *ngFor="let t of this.WeightTypes" [value]="t">
            {{t.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <p class="ShippingDetailsContainerBodyTitle">{{'TransportedBoxesInformation' | translate}}</p>

      <button [disabled]="parent.loading" class="AddNewPackageButton" mat-raised-button color="primary" (click)="AddNewBox();" style="margin-bottom: 10px;">{{'AddNewParcel' | translate}}</button>
      <button [disabled]="parent.loading" class="TransportationCostButton" mat-raised-button color="accent" (click)="UpdateDocumentTransportationCost(this.CurrentInvoice);" style="margin-bottom: 10px;">
        <i class="material-icons">view_in_ar</i>
        <span>{{'CheckInvoicesTransportationCosts' | translate}}</span>
      </button>

      <div class="ParcelContainerHeadder" *ngIf="this.CurrentInvoice?.Details?.ShippingDetails?.Boxes?.length > 0;">

        <div class="ParcelIndexHeadder">
            <span>#</span>
        </div>

        <div class="ParcelDimentionHeadder">
          <span>{{ 'Length' | translate }}</span>
        </div>

        <i class="material-icons BetweenDimentionsX">close</i>

        <div class="ParcelDimentionHeadder">
          <span>{{ 'Width' | translate }}</span>
        </div>

        <i class="material-icons BetweenDimentionsX">close</i>

        <div class="ParcelDimentionHeadder">
          <span>{{ 'Height' | translate }}</span>
        </div>

        <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

        <div class="ParcelDimentionHeadder">
          <span>{{ 'Weight' | translate }}</span>
        </div>

        <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

        <div class="ParcelDimentionHeadder">
          <span>{{ 'WeightType' | translate }}</span>
        </div>

        <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

        <div class="ParcelDimentionHeadder" style="width: auto; max-width: 220px;">
          <span>{{ 'TrackingLabel' | translate }}</span>
        </div>

      </div>

      <div class="ParcelContainer" *ngFor="let box of this.CurrentInvoice.Details.ShippingDetails.Boxes; let j=index;" style="border-bottom: solid 1px #ddd;">
        <div class="ParcelIndex">
         <span *ngIf="box.IsPallet != true;">{{'Parcel' | translate}}</span>
         <span *ngIf="box.IsPallet == true;">{{'Pallet' | translate}}</span>
         <span>#{{j + 1}}</span>
        </div>
        
        <mat-form-field appearance="outline" class="ParcelDimention">
          <mat-label>{{ 'Length' | translate }}*</mat-label>
          <input matInput placeholder="{{'Length' | translate}}" autocomplete="off" [(ngModel)]="box.Length" (click)="$event.target.select()">
        </mat-form-field>

        <i class="material-icons BetweenDimentionsX">close</i>

        <mat-form-field appearance="outline" class="ParcelDimention">
          <mat-label>{{ 'Width' | translate }}*</mat-label>
          <input matInput placeholder="{{'Width' | translate}}" autocomplete="off" [(ngModel)]="box.Width" (click)="$event.target.select()">
        </mat-form-field>

        <i class="material-icons BetweenDimentionsX">close</i>

        <mat-form-field appearance="outline" class="ParcelDimention">
          <mat-label>{{ 'Height' | translate }}*</mat-label>
          <input matInput placeholder="{{'Height' | translate}}" autocomplete="off" [(ngModel)]="box.Height" (click)="$event.target.select()">
        </mat-form-field>

        <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

        <mat-form-field appearance="outline" class="ParcelDimention">
          <mat-label>{{this.CurrentInvoice?.Details?.ShippingDetails?.WeightType?.Name}}*</mat-label>
          <input matInput placeholder="{{'Weight' | translate}}" autocomplete="off" [(ngModel)]="box.Weight" (click)="$event.target.select()">
        </mat-form-field>

        <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

        <mat-checkbox class="PalletCheckBox" [(ngModel)]="box.IsPallet">{{'Pallet' | translate}}?</mat-checkbox>

        <i class="material-icons BetweenDimentionsX" style="line-height: 35px;">minimize</i>

        <mat-form-field appearance="outline" class="BoxTrackingLabel">
          <mat-label>{{ 'TrackingLabel' | translate }}</mat-label>
          <input matInput placeholder="{{'TrackingLabel' | translate}}" autocomplete="off" [(ngModel)]="box.TrackingLabel">
        </mat-form-field>

        <div class="boxStatus" *ngIf="box.ID > 0;">
          <i class="material-icons">check</i>
        </div>

        <div class="boxStatus">
          <i class="material-icons" style="color: red;cursor: pointer;" (click)="CurrentBox = box; ShowDeleteBoxQuestion = true;">close</i>
        </div>
      </div>

    </div>
    <div class="ShippingDetailsContainerCommands">
      <button *ngIf="this.CurrentInvoice.Details.ShippingDetails?.ID > 0;" mat-raised-button color="warn" style="float:left;" (click)="ShowDeleteShippingDetailsContainer = true;" matTooltipClass='neutral-tool-tip'>
        <i class="material-icons ">delete_forever</i>
      </button>
      <button mat-raised-button color="primary" style="float:right;" (click)="ShowShippingDetailsContainer = false;" matTooltip="{{ 'NoSavingAtDBLevelWarning' | translate }}" matTooltipClass='neutral-tool-tip'>OK</button>
      <button mat-raised-button color="accent" style="float:right;margin-right: 10px;" (click)="ProofShippingDetails(this.CurrentInvoice.Details.ShippingDetails, true);" matTooltip="{{ 'SaveToDBDescription' | translate }}" matTooltipClass='neutral-tool-tip'>{{'SaveToDB' | translate}}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowProformaInvoiceConvertorQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowProformaInvoiceConvertorQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'ProformaInvoiceConversionTitle' | translate }} -  {{this.CurrentInvoice.AccountingNumber.DisplayValue}}
    </div>
    <div class="InfoQuestionBody">
      {{ 'ProformaInvoiceConversionQuestion' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowProformaInvoiceConvertorQuestion = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton ConvertToInvoiceFromProformaButton" (click)="ConvertProformaToInvoice(CurrentInvoice.ID);">
        <i class="material-icons">domain_verification</i>
        {{ 'ConvertToInvoice' | translate }}
      </button>
    </div>
  </div>

  <div class="animated fadeInDown CashCollectionContainer" *ngIf="SellThroughPartnerSelectSellingPartner">
    <div class="PopUpCloseContainer" (click)="SellThroughPartnerSelectSellingPartner = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="PopUpTitleContainer">
      <p>{{ 'SellThroughAPartner' | translate }}</p>
     </div>

     <div class="PopUpBody" style="margin-top: 20px;">

          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'ChoosePartner' | translate }}</mat-label>
            <mat-select name="SellingPartners" [(ngModel)]="SellingPartner" [compareWith]="compareFn">
              <mat-option *ngFor="let c of this.SellingPartners;" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        
     </div>

     <div class="PopUpCommands">
      <button *ngIf="SellingPartner != undefined;" [disabled]="loadingInvoicePurchasePrices" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="GetInvoicePurchasePrices(this.CurrentInvoice);">
          <span>{{'Continue' | translate}}</span>
      </button>
      <button [disabled]="true" *ngIf="SellingPartner == undefined;" [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton">
        <span>{{'FirstChoosePartner' | translate}}</span>
      </button>
    </div>

    <mat-progress-bar mode="query" *ngIf="loadingInvoicePurchasePrices"></mat-progress-bar>
  </div>

  <div class="animated fadeInDown CashCollectionContainer" *ngIf="SellThroughPartnerSelectSellingPartnerPart2" style="width: 40%;left:35%;">
    <div class="PopUpCloseContainer" (click)="SellThroughPartnerSelectSellingPartnerPart2 = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="PopUpTitleContainer">
      <p>{{ 'SellThroughAPartner' | translate }}</p>
     </div>

     <div class="PopUpBody" style="margin-top: 20px;">

      <div *ngIf="this.ProductsPurchasePricesToBeCompleted == 0;">
        <p class="NoProductsPurchasePricesToBeCompleted">{{'AllProductsContainPurchasePricesMessage' | translate}}</p>
      </div>
      <div *ngIf="this.ProductsPurchasePricesToBeCompleted > 0;">
        <p style="color: #f60;" class="NoProductsPurchasePricesToBeCompleted">{{'NotAllProductsContainPurchasePricesMessage' | translate}}</p>
      </div>

      <div *ngFor="let p of this.CurrentInvoice.Products;">
        <div class="CompletePurcahsePriceProductMasterContainer" *ngIf="p.ProductInvoiceInfo.GeneralType.ID == 1;" [ngClass]="{'CompletePurcahsePriceProductMasterContainerMustbeCompleted': p.ProductInvoiceInfo.PurchaseInfo.Status.ID == 0}">
          <div class="CompletePurcahsePriceProductContainer">
            <p class="CompletePurcahsePriceProductContainerSubInfoTitle" style="margin-bottom: 20px;">{{p.ProductInvoiceInfo.Name}}</p>
            <p class="CompletePurcahsePriceProductContainerSubInfo"><span style="color:#f60;">{{'ProductCode' | translate}}</span>: [{{p.ProductInvoiceInfo.Code}}]</p>
            <p class="CompletePurcahsePriceProductContainerSubInfo" style="margin-bottom: 10px;"><span style="color:#0082e6;">{{'Quantity' | translate}}</span>: {{p.ProductInvoiceInfo.Quantity}}</p>
           
            <p class="CompletePurcahsePriceProductContainerSubInfo"><span style="color:#0082e6;">{{'UIUnitPrice' | translate}}</span>: {{p.ProductInvoiceInfo.Price.UIUnitPrice}} [{{this.CurrentInvoice.Currency.Name}}]</p>
            <p class="CompletePurcahsePriceProductContainerSubInfo"><span style="color:#0082e6;">{{'UIQtyPrice' | translate}}</span>: {{p.ProductInvoiceInfo.Price.UIQtyPrice}} [{{this.CurrentInvoice.Currency.Name}}]</p>
            <p class="CompletePurcahsePriceProductContainerSubInfo"><span style="color:#0082e6;">{{'VATValue' | translate}}</span>: {{p.ProductInvoiceInfo.Price.VATValue}} [{{this.CurrentInvoice.Currency.Name}}]</p>
            <p class="CompletePurcahsePriceProductContainerSubInfo" style="margin-bottom: 10px;"><span style="color:#0082e6;">{{'TotalVATValue' | translate}}</span>: {{p.ProductInvoiceInfo.Price.TotalVATValue}} [{{this.CurrentInvoice.Currency.Name}}]</p>

            <p class="CompletePurcahsePriceProductContainerSubInfo"><span style="color:#32aa3a;">{{'Total' | translate}}</span>: {{p.ProductInvoiceInfo.Price.UIQtyVATPrice}} [{{this.CurrentInvoice.Currency.Name}}]</p>
            <p *ngIf="p.ProductInvoiceInfo.PurchaseInfo.Status.ID == 0" class="CompletePurcahsePriceProductContainerAutocompleteStatus">{{'SystemTriedToAutocomplete' | translate}}</p>
          </div>
          <div class="CompletePurcahsePriceProductContainerPrice">
            <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
              <mat-label>{{ 'PurchasePriceNoVAT' | translate }} {{this.CurrentInvoice.Currency.Name}}</mat-label>
              <input [(ngModel)]="p.ProductInvoiceInfo.Price.UIUnitPrice" matInput placeholder="{{ 'PurchasePriceNoVAT' | translate }} {{this.CurrentInvoice.Currency.Name}}" autocomplete="off" (change)="GetPriceInformation(p);">
            </mat-form-field>

            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
              <mat-label>{{ 'VATRate' | translate }}</mat-label>
              <mat-select name="ProductVATRate" [(ngModel)]="p.ProductInvoiceInfo.VAT" [compareWith]="compareFn">
                <mat-option *ngFor="let v of this.VATRates;" [value]="v" (click)="p.ProductInvoiceInfo.Price.VAT = v;GetPriceInformation(p);">
                  {{v.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
     </div>

     <div class="PopUpCommands">
      <button *ngIf="SellingPartner != undefined;" [disabled]="loadingInvoicePurchasePrices" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="ProofSellThroughPartnerStepTwo();">
          <span>{{'Continue' | translate}}</span>
      </button>
    </div>

    <mat-progress-bar mode="query" *ngIf="loadingInvoicePurchasePrices"></mat-progress-bar>
  </div>

  <div class="animated fadeInDown CashCollectionContainer" *ngIf="SellThroughPartnerSelectSellingPartnerPart3">
    <div class="PopUpCloseContainer" (click)="SellThroughPartnerSelectSellingPartnerPart3 = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="PopUpTitleContainer">
      <p>{{ 'SellThroughAPartner' | translate }}</p>
     </div>

     <div class="PopUpBody" style="margin-top: 20px;">
       <p class="PopUpBodyMessage">{{'ConfirmAndSubmitDescription' | translate}}</p>
     </div>

     <div class="PopUpCommands">
      <button [disabled]="loadingInvoicePurchasePrices" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="SellThroughPartner();">
        <span>{{'ConfirmAndSubmit' | translate}}</span>
      </button>
    </div>

    <mat-progress-bar mode="query" *ngIf="loadingInvoicePurchasePrices"></mat-progress-bar>
  </div>

  <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSellthroughPartnerProfitsRecallibration" style="width: 50%; left: 30%;">
    <div class="PopUpCloseContainer" (click)="CloseSellthroughPartnerProfitsRecallibration();">
      <i class="material-icons">close</i>
    </div>

    <div class="PopUpTitleContainer">
      <p>{{ 'SellthroughPartnerProfitsRecallibration' | translate }}</p>
     </div>

     <div class="PopUpBody" style="margin-top: 20px;max-height: 600px;">
       <p class="PopUpBodyMessage">{{'SellthroughPartnerProfitsRecallibrationDescription' | translate}}</p>

          <p class="sliderTitle">{{'ProfitInitialCompany' | translate }}</p>
          <mat-slider
          class="ProfitSlider"
          [disabled]="false"
          [invert]="false"
          [max]="100"
          [min]="0"
          [step]="1"
          [thumbLabel]="true"
          [tickInterval]="getSliderTickInterval()"
          [(ngModel)]="ProfitInitial"
          [vertical]="false"
          aria-labelledby="example-name-label">
          </mat-slider>

          <p class="sliderTitle">{{'ProfitFinalSellingCompany' | translate }}</p>
          <mat-slider
          class="ProfitSlider"
          [disabled]="false"
          [invert]="false"
          [max]="100"
          [min]="0"
          [step]="1"
          [thumbLabel]="true"
          [tickInterval]="getSliderTickInterval()"
          [(ngModel)]="100 - ProfitInitial"
          [vertical]="false"
          aria-labelledby="example-name-label">
          </mat-slider>

       <div class="SalesDocumentsTraceContainer">
        <div *ngFor="let trace of this.SalesDocumentsTraces; let i=index;" class="SalesDocumentsTrace">
          <p class="SalesDocumentsTraceTitle" style="font-size:10px;">
            <span>{{trace.InitialInvoice.Company.Name}}</span>
            <i class="material-icons">compare_arrows</i>
            <span>{{trace.FinalClientInvoice.Company.Name}}</span>  
          </p>

          <p class="SalesDocumentsTraceTitle" style="margin-bottom: 25px;">
            <span>{{trace.InitialInvoice.AccountingNumber.DisplayValue}}</span>
            <i class="material-icons">arrow_right_alt</i>
            <span>{{trace.Reception.AccountingNumber.DisplayValue}}</span>  
            <i class="material-icons">arrow_right_alt</i>
            <span>{{trace.FinalClientInvoice.AccountingNumber.DisplayValue}}</span>  
          </p>

          <p class="sliderTitle">Profit {{trace.InitialInvoice.Company.Name}}</p>
          <mat-slider
          class="ProfitSlider"
          [disabled]="true"
          [invert]="false"
          [max]="100"
          [min]="0"
          [step]="1"
          [thumbLabel]="true"
          [tickInterval]="getSliderTickInterval()"
          [(ngModel)]="ProfitInitial"
          [vertical]="false"
          aria-labelledby="example-name-label">
          </mat-slider>

          <p class="sliderTitle">Profit {{trace.FinalClientInvoice.Company.Name}}</p>
          <mat-slider
          class="ProfitSlider"
          [disabled]="true"
          [invert]="false"
          [max]="100"
          [min]="0"
          [step]="1"
          [thumbLabel]="true"
          [tickInterval]="getSliderTickInterval()"
          [(ngModel)]="100 - ProfitInitial"
          [vertical]="false"
          aria-labelledby="example-name-label">
          </mat-slider>

          <mat-slide-toggle [(ngModel)]="trace.IsSelected" class="SalesDocumentsTraceCheck" matTooltip="{{ 'SelectedForProfitRecallibration' | translate }}" matTooltipClass='neutral-tool-tip'></mat-slide-toggle>
        </div>
       </div>
       
     </div>

     <div class="PopUpCommands">
      <button [disabled]="loadingInvoicePurchasePrices" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="ShowSellthroughPartnerProfitsRecallibration = false; ShowRecallibrateProfitsSTPFinal = true;">
        <span>{{'ConfirmAndSubmit' | translate}}</span>
      </button>
    </div>

    <mat-progress-bar mode="query" *ngIf="loadingProfitsRecallibration"></mat-progress-bar>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowAutoPrintBulkQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowAutoPrintBulkQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'AutoPrintBulkTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'AutoPrintBulkDescription' | translate }}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowAutoPrintBulkQuestion = false;">{{ 'No' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowAutoPrintBulkQuestion = false; AutoPrintInvoices();">{{ 'Yes' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowExportBulkQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowExportBulkQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'AutoExportDocsBulkTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'AutoExportDocsBulkDescription' | translate }}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowExportBulkQuestion = false;">{{ 'No' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowExportBulkQuestion = false; AutoExportInvoices();">{{ 'Yes' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowCombineInOneInvoiceQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowCombineInOneInvoiceQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'CombineInOneInvoiceTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      <p>{{ 'CombineInOneInvoiceDescription' | translate }}</p>
      <mat-form-field class="SecuritPINInput">
        <mat-label>{{ 'SecurityPIN' | translate }}</mat-label>
        <input matInput placeholder="{{ 'SecurityPIN' | translate }}" [type]="hide ? 'password' : 'text'" [(ngModel)]="this.CombineInOneInvoiceSecurityPIN" required>
      </mat-form-field>
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowCombineInOneInvoiceQuestion = false;">{{ 'No' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowCombineInOneInvoiceQuestion = false; MergeInvoices();">{{ 'Yes' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowAdvancePaymentInvoiceToFinancialInvoiceQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowAdvancePaymentInvoiceToFinancialInvoiceQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'AdvanceInvoiceConversionTitle' | translate }} -  {{this.CurrentInvoice.AccountingNumber.DisplayValue}}
    </div>
    <div class="InfoQuestionBody">
      {{ 'AdvanceInvoiceConversionQuestion' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowAdvancePaymentInvoiceToFinancialInvoiceQuestion = false;">
        {{ 'Configuration.DeleteNoButton' | translate }}
      </button>
      <button (click)="ConvertAdvancePaymentInvoiceToFinancialInvoice(this.CurrentInvoice.ID);" [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton ConvertToInvoiceFromProformaButton">
        <i class="material-icons">verified</i>
        {{ 'ConvertFromAdvanceToInvoice' | translate }}
      </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteInvoiceRelatedCashCollections">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteInvoiceRelatedCashCollections = false; CashCollections = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'ShowDeleteInvoiceRelatedCashCollections' | translate }} | {{'CashCollections' | translate}}: [{{this.CashCollections?.length}}]
    </div>
    <div class="InfoQuestionBody">
      {{ 'ShowDeleteInvoiceRelatedCashCollectionsDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteInvoiceRelatedCashCollections = false; CashCollections = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteInvoiceRelatedCashCollections = false;DeleteCashCollections(CashCollections);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSpendingQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteSpendingQuestion = false; currentSpending = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false; currentCashCollettion = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false;DeleteCashCollection(currentCashCollettion.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeactivateDocumentQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeactivateDocumentQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'DocumentDeactivationTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'DocumentDeactivationDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false;">{{ 'No' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false;CancelOrActivate(CurrentInvoice.ID, true);">{{ 'Yes' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowReactivateDocumentQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowReactivateDocumentQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'DocumentReactivationTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'DocumentReactivationDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowReactivateDocumentQuestion = false;">{{ 'No' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowReactivateDocumentQuestion = false;CancelOrActivate(CurrentInvoice.ID, False);">{{ 'Yes' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteInvoiceQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteInvoiceQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteInvoiceQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteInvoiceQuestion = false;DeleteInvoice(CurrentInvoice);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowEFacturaBulkQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowEFacturaBulkQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'ShowEFacturaBulkQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'ShowEFacturaBulkQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteInvoiceQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="UploadEFacturaBulk();">{{ 'Send' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowEFacturaQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowEFacturaQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'ShowEFacturaQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'ShowEFacturaQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading || this.DocumentBodyLoading" mat-raised-button class="InfoQuestionButton" (click)="ShowEFacturaQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading || this.DocumentBodyLoading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="UploadEFactura(this.CurrentInvoice);">{{ 'Send' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowANAFRedirectionNotification">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowANAFRedirectionNotification = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'ShowANAFRedirectionNotification' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'ShowANAFRedirectionNotificationDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowANAFRedirectionNotification = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="this.parent.RedirectToURLNewTab(this.EFacturaGeneralData.UserRedirectURL); ShowANAFRedirectionNotification = false;">{{ 'ANAFRedirectionNotificationButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="SingleCurrencyOnCollectivePaymentError">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="SingleCurrencyOnCollectivePaymentError = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
     {{'SingleCurrencyError' | translate}}
    </div>
    <div class="InfoQuestionBody">
      {{'SingleCurrencyErrorDesc' | translate}}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" color="warn" mat-raised-button class="InfoQuestionButton" (click)="SingleCurrencyOnCollectivePaymentError = false;">
        {{ 'OK' | translate }}
      </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeactivatedDocumentsOnSelectAllQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeactivatedDocumentsOnSelectAllQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
     {{'CanceledDocumentsFound' | translate}}
    </div>
    <div class="InfoQuestionBody">
      {{'CanceledDocumentsFoundDescription' | translate}}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" color="warn" mat-raised-button class="InfoQuestionButton" style="background-color: #f60;" (click)="InitializeNewCollectiveCollection();">
        <i class="material-icons">warning_amber</i>
        {{ 'Include' | translate }}
      </button>
      <button [disabled]="this.parent.loading" color="accent" mat-raised-button class="InfoQuestionButton" (click)="DeselectDeactivatedDocs();InitializeNewCollectiveCollection();">
        <i class="material-icons">forward</i>
        {{ 'IgnoreCanceledDocuments' | translate }}
      </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ExportAllOrPageOnlyQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ExportAllOrPageOnlyQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'ExportAllOrPageOnlyQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'ExportAllOrPageOnlyQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button color="accent" class="InfoQuestionButton" (click)="ExportAllOrPageOnlyQuestion = false;ExportInvoicesValues();">
        <i class="material-icons">download</i>
        {{ 'ExportPage' | translate }}
      </button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ExportAllOrPageOnlyQuestion = false;ExportInvoicesValues(true);">
        <i class="material-icons">download</i>
        {{ 'ExportAllPages' | translate }}
      </button>
    </div>
  </div>

  <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestionCashCollectionsContainer" style="left: 16%;width: 83%;">
    <div class="PopUpCloseContainer" (click)="ShowSuggestionCashCollectionsContainer = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="PopUpTitleContainer" style="height: auto;padding-left: 0;padding-right: 0;">
      <p>{{ 'CashCollections' | translate }}</p>

      <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;width: 95%;margin-left: 2.5%;margin-top: 15px;">
        <div class="ReceptionProductsCol" style="width: 5%;">
          {{ 'Invoice' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 15%;">
          {{ 'Client' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 10%;">
          {{ 'CashColletcionDate' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 10%;">
          {{ 'Value' | translate }} 
        </div>
        <div class="ReceptionProductsCol" style="width: 10%;">
          {{ 'CashCollectionType' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 5%;">
            {{ 'Currency' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 5%;">
            {{ 'Receptions.ExchangeRate' | translate }}
          </div>
        <div class="ReceptionProductsCol" style="width: 10%;">
          {{ 'Receptions.DecimalPercision' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 20%;">
            {{ 'CollectionExternalID' | translate }}
        </div>
        <div class="ReceptionProductsCol" style="width: 10%;">
            {{ 'Actions' | translate }}
        </div>
      </div>
     </div>

     <div class="PopUpBody" style="margin-top: 5px;">

    <div class="ReceptionProductsContainer  top-box">

        <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
        </div>

        <div *ngIf="!loading">
            <div class="ReceptionProductsRow" *ngFor="let c of this.CashCollections; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Status.ID == -1, 'AssociatedPayment': c.Status.ID == 1}">
                <div class="ReceptionProductsCol" style="width: 5%;">
                 <span *ngIf="c.Status.ID == 1;">{{c.DisplayValue}}</span>
                 <span *ngIf="c.Status.ID == -1;">---</span>
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                    <span *ngIf="c.Status.ID == 1;">{{c.Client.Name}}</span>
                    <span *ngIf="c.Status.ID == -1;">[ {{c.Status.Name}} ]</span>
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  {{c.CollectionDateUI}}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  {{c.Value}} 
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  {{c.Type.Name}}
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                    {{c.Currency.Name}}
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                    <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                    <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                  </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    {{c.Currency.DecimalPrecision?.ID}}
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;">
                    {{c.CollectionExternalID}}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    <i class="material-icons ReceptionProductEdit" (click)="OpenSuggestedCashCollectionModifier(c); ShowSuggestedCashCollectionModifier = true;">edit</i>
                    <i class="material-icons ReceptionProductEdit" style="color: red;" (click)="CloneCashCollection(c); ShowDeleteSpendingQuestion = true;">close</i>
                </div>
            </div>
        </div>

      
    </div>
    
     </div>

     <div class="PopUpCommands" style="height: auto;min-height: 50px;padding-bottom: 15px;">
        <div *ngIf="this.CashCollections != null && this.CashCollections.length > 0 && !loading;">
            <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.CashTotals; let i=index;">
                <div class="ReceptionProductsCol" style="width: 5%;">
                     
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                    {{this.CashCollections.length}} {{'CashCollections' | translate}}
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                    Total:
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                  <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                    {{Total.Currency.Name}}
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                    
                </div>
                <div class="ReceptionProductsCol totalCol" style="width: 10%;">
                    
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;">
                  
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                    
                </div>
            </div>
        </div>
    </div>
  </div>

  <div class="EFacturaSendMenu animated fadeInDown" *ngIf="ShowEFacturaSendMenu">

  </div>
  
    <div class="animated fadeInDown DocumentContainer" *ngIf="showInvoiceVisualizer">

        <div class="InvoiceModelSettings animated fadeIn" *ngIf="this.CurrentInvoice.ModelSettings.ShowInvoiceSettings == true;">
          <div class="InvoiceModelSettingsTopContainer">
            <mat-form-field class="InvoiceModelSelect" appearance="outline">
              <mat-label>{{ 'InvoiceModel' | translate }}</mat-label>
              <mat-select [compareWith]="compareFn" name="InvoiceModels" [(ngModel)]="this.CurrentInvoice.ModelSettings.InvoiceModel">
                <mat-option *ngFor="let m of this.InvoiceModels;" [value]="m">
                  {{m.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="InvoiceModelSettingsContainer">
            <mat-slide-toggle matTooltip="{{ 'UseForDocumentSeries' | translate }}" matTooltipClass='neutral-tool-tip' class="InvoiceModelSlideToggle" [(ngModel)]="this.UseForDocumentSeries">{{'UseForDocumentSeries' | translate}}</mat-slide-toggle>
            <mat-slide-toggle matTooltip="{{ 'OverWriteForDocumentSeries' | translate }}" matTooltipClass='neutral-tool-tip' class="InvoiceModelSlideToggle" [(ngModel)]="this.OverWriteForDocumentSeries">{{'OverWriteForDocumentSeries' | translate}}</mat-slide-toggle>
          
            <button mat-raised-button color="primary" class="InvoiceModelButton" (click)="AddUpdateInvoiceModelSettings();">{{'Save' | translate}}</button>
          </div>
        </div>

        <div class="PopUpCloseContainer" (click)="showInvoiceVisualizer = false;">
            <i class="material-icons">close</i>
        </div>

        <div class="InvoiceVisualizerTitle">
          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="InvoiceModelChangeButton" mat-raised-button (click)="OpenInvoiceModelSettings();">
            <i class="material-icons" *ngIf="this.CurrentInvoice.ModelSettings.ShowInvoiceSettings != true;">keyboard_arrow_left</i>
            <i class="material-icons" *ngIf="this.CurrentInvoice.ModelSettings.ShowInvoiceSettings == true;">keyboard_arrow_right</i>
            <i class="material-icons" style="font-size: 18px;">settings</i>
          </button>
          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="EfacturaButton" mat-raised-button (click)="GetEFacturaXML(this.CurrentInvoice);">
            <i class="material-icons">download</i>
            <span>{{'DownloadEFactura' | translate}}</span>
          </button>

          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="EfacturaButton" mat-raised-button color="accent" (click)="this.ShowEFacturaQuestion = true;" *ngIf="this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == -1 || this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == 0;">
            <i class="material-icons">play_arrow</i>
            <span>{{'APIEFactura' | translate}}</span>
          </button>

          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="EfacturaButton" mat-raised-button (click)="GetEFacturaFiles(this.CurrentInvoice);" *ngIf="this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID == 2;">
            <i class="material-icons">downloading</i>
            <span>{{'DownloadEFacturaPDF' | translate}}</span>
          </button>

          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" class="EfacturaButton" mat-raised-button color="primary" (click)="GetEFacturaState(this.CurrentInvoice);" *ngIf="this.CurrentInvoice.Details?.EFacturaDetails?.Status?.ID >= 1;">
            <i class="material-icons">sync</i>
            <span>{{'UpdateEFacturaStatus' | translate}}</span>
          </button>

          <button (click)="ShuffleElements(1, this.CurrentInvoice);" class="InvoiceInterChangeButton" mat-raised-button><i class="material-icons">keyboard_arrow_up</i></button>
          <button (click)="ShuffleElements(-1, this.CurrentInvoice);" class="InvoiceInterChangeButton" mat-raised-button><i class="material-icons">keyboard_arrow_down</i></button>
         </div> 
      
         <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
          <button [matMenuTriggerFor]="exportMenu" [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button color="primary" class="VizualizeCommandButton" style="outline: none;">
            <i class="material-icons">file_copy</i>
            <span>{{ 'Receptions.Document.Export' | translate }}</span>
          </button>

          <mat-menu #exportMenu="matMenu">
            <button mat-menu-item class="ReceptionMenuButton" (click)="ExportInvoice(this.CurrentInvoice, 0);">
              <i class="material-icons">file_copy</i>
              <span>{{ 'ExportPDF' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" (click)="ExportInvoice(this.CurrentInvoice, 1);">
              <i class="material-icons">file_present</i>
              <span>{{ 'ExportExcel' | translate }}</span>
            </button>
          </mat-menu>
      
          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" style="outline: none;" (click)="PrintInvoice(this.CurrentInvoice);">
            <i class="material-icons">print</i>
            <span>{{ 'Receptions.Document.Print' | translate }}</span>
          </button>

          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" style="outline: none;" (click)="this.parent.InitializeEmailSendContainer(this.CurrentInvoice.Client, this.CurrentInvoice.GeneralDocType, this.CurrentInvoice.ID);">
            <i class="material-icons">attach_email</i>
            <span>{{ 'Email' | translate }}</span>
          </button>

          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" style="outline: none;" *ngIf="this.CurrentInvoice.Details?.ShippingDetails?.TrackingLabel?.length > 0;" (click)="TrackInvoice(CurrentInvoice);">
            <i class="material-icons">near_me</i>
            <span>{{ 'Track' | translate }}</span>
          </button>

          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" mat-raised-button class="VizualizeCommandButton" [matMenuTriggerFor]="menuPopUpInvoice">
            <i class="material-icons">settings</i>
              <span>{{'Actions' | translate}}</span>
            </button>
          <mat-menu #menuPopUpInvoice="matMenu">
            <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1 && CurrentInvoice.DocType.ID == 1 && CurrentInvoice.IsStorno == false;" (click)="ConvertProformaToInvoiceQuestion(CurrentInvoice);">
              <i class="material-icons">domain_verification</i>
              <span>{{ 'ConvertToInvoice' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1 && CurrentInvoice.DocType.ID == 2 && CurrentInvoice.IsStorno == false;" (click)="ConvertAdvancePaymentInvoiceToFinancialInvoiceQuestion(CurrentInvoice);">
              <i class="material-icons">domain_verification</i>
              <span>{{ 'ConvertFromAdvanceToInvoice' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" (click)="ViewInvoice(CurrentInvoice);">
                <i class="material-icons">mode_edit</i>
                <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" (click)="GenerateInvoicesDeliveryNote(CurrentInvoice);">
              <i class="material-icons">sticky_note_2</i>
              <span>{{ 'DeliveryNote' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" (click)="PrepareETransportStep1();">
              <i class="material-icons">qr_code_2</i>
              <span>{{ 'ETransportGeneration' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" (click)="InitializeNewCashCollection(CurrentInvoice);">
                <i class="material-icons">monetization_on</i>
                <span>{{ 'Collect' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1 && CurrentInvoice.IsStorno != true && CurrentInvoice.DocType.ID != 1;" (click)="GenerateNewInvoice(CurrentInvoice, true, false);">
                <i class="material-icons">settings_backup_restore</i>
                <span>{{ 'Receptions.Table.ButtonMenu.stornate' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" (click)="this.ShowDeactivateDocumentQuestion = true;">
                <i class="material-icons">close</i>
                <span>{{ 'Receptions.Table.ButtonMenu.cancelDoc' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" *ngIf="CurrentInvoice.DocumentStatus.ID == -1;" (click)="this.ShowReactivateDocumentQuestion = true;">
                <i class="material-icons">verified</i>
                <span>{{ 'Receptions.Table.ButtonMenu.reactivateDoc' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" (click)="GenerateNewInvoice(CurrentInvoice, false, true);">
                <i class="material-icons">content_copy</i>
                <span>{{ 'Copy' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" (click)="DeleteInvoice(CurrentInvoice);">
                <i class="material-icons">delete_forever</i>
                <span>{{ 'Receptions.Table.ButtonMenu.delete' | translate }}</span>
            </button>
            <button mat-menu-item class="ReceptionMenuButton" (click)="initializePartnerFormFromObject(CurrentInvoice.Client);showInvoiceVisualizer = false;">
                <i class="material-icons">person_search</i>
                <span>{{ 'ViewClient' | translate }}</span>
            </button>
          </mat-menu>

          <button [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintDocument(this.CurrentInvoice);" mat-raised-button class="VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
            <i class="material-icons">print</i>
            <span>{{ 'AutoPrint' | translate }}</span>
          </button>
      
          <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
        </div>
      
         <div class="PopUpBody" style="max-height: 80vh;">
            <p class="DocumentBodyCanceled" *ngIf="CurrentInvoice.DocumentStatus.ID == -1;">anulata</p>
      
            <div *ngIf="!CurrentInvoice.IsStorno" class="DocumentStatusContainer" [ngClass]="{'CancelledStatusPopUp': CurrentInvoice.DocumentStatus.ID == -1, 'CollectedStatusPopUp': CurrentInvoice.DocumentStatus.ID == 1,'PartiallyCollectedPopUp': CurrentInvoice.DocumentStatus.ID == 2,'SurplusCollectedPopUp': CurrentInvoice.DocumentStatus.ID == 3, 'CreatedStatusPopUp': CurrentInvoice.DocumentStatus.ID == 4, 'OverduePopUp': CurrentInvoice.DocumentStatus.ID == 5}">
              <span style="float: left;">{{CurrentInvoice.DocumentStatus.Name}}:</span>
              <span *ngIf="CurrentInvoice.DocumentStatus.ID == 5;"> ({{CurrentInvoice.OverduePaymentDays}} {{'DaysLate' | translate}}, {{CurrentInvoice.Details.EmailNotificationsCount}} {{'SendEmailNotifications' | translate}})</span>
              <div *ngIf="CurrentInvoice.DocumentStatus.ID != -1;" style="float: left;">
                <span *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue > 0;"> {{'RemainingToCashCollect' | translate}}: {{this.CurrentInvoice.Details.CashCollectionRemainingValue}} {{this.CurrentInvoice.Currency.Name}}</span>
                <span *ngIf="this.CurrentInvoice.Details.CashCollectionRemainingValue < 0;"> {{'OverCashCollected' | translate}}: {{this.CurrentInvoice.Details.CashCollectionRemainingValue}} {{this.CurrentInvoice.Currency.Name}}</span>
              </div>
            </div>

            <table style="border: solid 1px #aaa;
            padding: 20px;
            font-weight: 400;
            margin-top: 2.5%;
            position: relative;
            margin-bottom: 2.5px;
            border-collapse: separate !important;
            border-radius: 4px;margin-top: 5px;">
              <tbody>
                <tr>
                  <td style="border-radius: 3px;">
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="width: 50%;max-height: 100px;float: left;">
                          <img alt="{{this.CurrentInvoice.Company.Name}}" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath != null;" [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath" style="max-width: 50%;max-height: 100%;"/>
                          <td style="width: 75%;
                          float: left;
                          font-size: 26px;
                          font-weight: 700;
                          line-height: 30px;
                          text-transform: uppercase;" *ngIf="this.CurrentInvoice.AccountingNumber.AccountingSeries.LogoPath == null;">{{this.CurrentInvoice.Company.Name}}</td>
                        </tr>
                        <tr style="width: 50%;float: left;">
                           <table style="width: 100%;float: left;">
                             <tbody>
                              <tr style="width: 50%;float: left;font-size: 18px;font-weight: 700;text-transform: uppercase;">
                                {{CurrentInvoice.DocType.Meaning}}
                              </tr>
                              <tr style="width: 50%;float: left;text-align: right;font-weight: 700;font-size: 22px;padding-right: 5px;">
                                {{CurrentInvoice.AccountingNumber.DisplayValue}}
                              </tr>
                             </tbody>
                           </table>
              
                            <table style="width: 100%;float: left;margin-top: 10px;">
                              <tbody>
                                <tr style="width: 50%;float: left;font-size: 13px;">
                                  {{ 'CreatingDate' | translate }}: {{CurrentInvoice.EventRegisterUIDate}}
                                </tr>
                                <tr style="width: 50%;float: left;text-align: right;font-size: 13px;padding-right: 5px;" *ngIf="CurrentInvoice.VATs.length == 1;">
                                  {{ 'VATRate' | translate }}: <span *ngFor="let v of CurrentInvoice.VATs">{{v.Name}}</span>
                                </tr>
                              </tbody>
                            </table>
              
                           <table style="width: 100%;float: left;margin-top: 10px;">
                             <tbody>
                              <tr style="width: 100%;float: left;height: auto;background: #254a91;border-radius: 3px;line-height: 40px;text-align: right;color: #fff;font-size: 20px;font-weight: 500;">
                                <td style="float: left;width: 100%;padding: 0;">
                                 <table style="width: 100%;">
                                   <tbody>
                                    <tr style="width: 50%;float: left;font-size: 18px;text-align: left;padding-left: 10px;text-transform: uppercase;">
                                      {{ 'TotalValue' | translate }}
                                    </tr>
                                    <tr style="width: 50%;float: left;font-size: 18px;text-align: right;padding-right: 10px;text-transform: uppercase;">
                                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                                      <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                                      <span style="font-size: 14px;"> {{CurrentInvoice.Currency.Name}}</span>
                                    </tr>
                                   </tbody>
                                 </table>

                                 <table style="width: 100%;" *ngIf="CurrentInvoice.MainCurrency?.TotalDisplayValue != null;">
                                  <tbody>
                                   <tr style="width: 50%;min-height: 20px;float: left;font-size: 18px;text-align: left;padding-left: 10px;text-transform: uppercase;">
                                     
                                   </tr>
                                   <tr style="width: 50%;float: left;font-size: 12px;text-align: right;padding-right: 10px;text-transform: uppercase;line-height: 5px;">
                                     <span>{{CurrentInvoice.MainCurrency.UITotalDisplayValue.Integer}}</span>
                                     <span>{{CurrentInvoice.MainCurrency.UITotalDisplayValue.Decimals}}</span> 
                                     <span style="font-size: 12px;"> {{CurrentInvoice.MainCurrency.Name}}</span>
                                   </tr>
                                  </tbody>
                                </table>
                                </td>
                              </tr>
                             </tbody>
                           </table>
              
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                          <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                            <tr style="width: 60%;
                            float: left;
                            padding-left: 5px;
                            text-transform: uppercase;
                            font-weight: 500;
                            height: 30px;
                            line-height: 30px;
                            border-bottom: solid 2px #254a91;
                            margin-top: 10px;">{{ 'Supplier' | translate }}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 10px;
                            text-transform: uppercase;
                            font-weight: 700;
                            font-size: 16px;">{{this.CurrentInvoice.Company.Name}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 10px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Company.VATNumber}}</tr>
              
                             <tr style="width: 100%;
                             float: left;
                             padding-left: 5px;
                             margin-top: 0px;
                             text-transform: uppercase;
                             font-size: 12px;">{{ 'RegCom' | translate }}: {{this.CurrentInvoice.Company.COCRegisterNr}}</tr>
              
                             <tr style="width: 100%;
                             float: left;
                             padding-left: 5px;
                             margin-top: 0px;
                             text-transform: uppercase;
                             font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Company.Addresses[0].Country.Name}} 
                             {{this.CurrentInvoice.Company.Addresses[0].StateProvince}}
                             {{this.CurrentInvoice.Company.Addresses[0].City}}
                             {{this.CurrentInvoice.Company.Addresses[0].AddressLine}}</tr>
              
                             <tr style="width: 100%;
                             float: left;
                             padding-left: 5px;
                             margin-top: 0px;
                             text-transform: uppercase;
                             font-size: 12px;">{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{this.CurrentInvoice.Company.Banks[0]?.BankAccounts[0]?.Currency.Name}}) : {{this.CurrentInvoice.Company.Banks[0]?.BankAccounts[0]?.AccountNumber}}</tr>
              
                             <tr style="width: 100%;
                             float: left;
                             padding-left: 5px;
                             margin-top: 0px;
                             text-transform: uppercase;
                             font-size: 12px;">{{ 'Partners.PartnerWindow.Bank' | translate }}: {{this.CurrentInvoice.Company.Banks[0]?.Name}}</tr>
              
                          </td>
                        </tr>
                        <tr style="width: 50%;max-height: 200px;float: left;min-height: 50px;">
                          <td style="float: left;width: 100%;height: auto;min-height: 50px;padding: 0;">
                            <tr style="width: 60%;
                            float: left;
                            padding-left: 5px;
                            text-transform: uppercase;
                            font-weight: 500;
                            height: 30px;
                            line-height: 30px;
                            border-bottom: solid 2px #254a91;
                            margin-top: 10px;">{{ 'Client' | translate }}</tr> 
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 10px;
                            text-transform: uppercase;
                            font-weight: 700;
                            font-size: 16px;">{{this.CurrentInvoice.Client.Name}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 10px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'VAT' | translate }}: {{this.CurrentInvoice.Client.VAT}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 0px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'Partners.PartnerWindow.Address' | translate }} {{this.CurrentInvoice.Client.BillingAddress.StateProvince}} {{this.CurrentInvoice.Client.BillingAddress.City}} {{this.CurrentInvoice.Client.BillingAddress.AddressLine}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 0px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'Country' | translate }}: {{this.CurrentInvoice.Client.BillingAddress.Country.Name}}</tr>
              
                            <tr style="width: 100%;
                            float: left;
                            padding-left: 5px;
                            margin-top: 0px;
                            text-transform: uppercase;
                            font-size: 12px;">{{ 'Login.Email' | translate }}: {{this.CurrentInvoice.Client.ContactInfo.Email}}</tr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;margin-top: 20px;height: 2px;background: #254a91;">
                          
                        </tr>
                        <tr style="float: left;width: 100%;height: 50px;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            {{ 'Receptions.Table.Nr' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                            {{ 'Receptions.Table.Name' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            {{ 'Receptions.Table.MU' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            {{ 'Receptions.Table.Qty' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;">
                            {{ 'Receptions.Table.Price' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;">
                            {{ 'Receptions.Table.Total' | translate }} ({{this.CurrentInvoice.Currency.Name}})
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            {{ 'Receptions.Table.VAT' | translate }}
                          </td>
                        </tr>
                        <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #254a91;">
                          
                        </tr>
              
                        <tr style="float: left;width: 100%;height: auto;min-height: 12px;padding-bottom: 10px;" *ngFor="let p of CurrentInvoice.Products; let i=index;" [ngClass]="{'GrayRow': i % 2 != 0}">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 7.5%;text-align: center;">
                            {{i + 1}}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;height: auto;float: left;min-height: 12px;width: 30%;text-align: left;">
                            <p style="margin:0;margin-bottom:5px;">{{p.ProductInvoiceInfo.Name}}</p>
                            <p *ngFor="let row of p.ProductInvoiceInfo.DescriptionRows; let j=index;" style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;">
                                {{row}}
                            </p>
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                            {{p.ProductInvoiceInfo.MeasuringUnit.Name}}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                            {{p.ProductInvoiceInfo.Quantity}}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 17.5%;text-align: right;">
                            <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIUnitPrice}}</span>
                            <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIUnitPriceDiscount}}</span>
              
                            <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">
                              Discount - {{p.ProductInvoiceInfo.Price.Discount.Value}} 
                              <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">%</span>
                              <span *ngIf="p.ProductInvoiceInfo.Price.Discount.Type.ID == 2;">{{this.CurrentInvoice.Currency.Name}}</span>
                            </p>
                            <p style="height: auto;margin:0;min-height: 16px;line-height: 16px;color: #aaa;font-weight: 400;" *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null && p.ProductInvoiceInfo.Price.Discount.Type.ID == 1;">
                              Initial - {{p.ProductInvoiceInfo.Price.UIUnitPrice}} {{this.CurrentInvoice.Currency.Name}}
                            </p>
              
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 15%;text-align: right;">
                            <span *ngIf="p.ProductInvoiceInfo.Price.Discount == null || p.ProductInvoiceInfo.Price.Discount.Value == null">{{p.ProductInvoiceInfo.Price.UIQtyPrice}}</span>
                            <span *ngIf="p.ProductInvoiceInfo.Price.Discount != null && p.ProductInvoiceInfo.Price.Discount.Value != null">{{p.ProductInvoiceInfo.Price.UIQtyPriceDiscount}}</span>
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 10%;text-align: center;">
                            <span>{{p.ProductInvoiceInfo.Price.TotalVATValue}}</span>
                          </td>
                        </tr>
              
                        <tr style="float: left;width: 100%;margin-top: 0px;height: 2px;background: #aaa;">
                          
                        </tr>
              
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: 50px;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            {{ 'InvoiceCreator' | translate }}:
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;text-transform: capitalize;">
                            {{this.CurrentInvoice.Details.Agent.Name}}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                            Total:
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 17.5%;text-align: right;background: #f6f6f6;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: right;background: #f6f6f6;">
                               <span>{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Integer}}</span>
                               <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalQtyPriceNOVAT.Decimals}}</span> 
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;background: #f6f6f6;">
                            <span>{{CurrentInvoice.Total.UITotalVAT.Integer}}</span>
                            <span style="font-size: 12px;">{{CurrentInvoice.Total.UITotalVAT.Decimals}}</span> 
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: 50px;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                            {{ 'TotalPayment' | translate }}
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 18px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                            <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Integer}}</span>
                            <span>{{CurrentInvoice.Total.UITotalQtyPriceVAT.Decimals}}</span> 
                            <span> {{CurrentInvoice.Currency.Name}}</span>
                          </td>
                        
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: 50px;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                            {{ 'PaymentTerms' | translate }}:
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                             {{this.CurrentInvoice.PaymentDueDateUI}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;" *ngIf="CurrentInvoice.Details.Agent != null && CurrentInvoice.Details.Agent.ID != null && CurrentInvoice.Details.IsSignedByAgent && this.Products.length > 0;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: auto;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                        
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 10%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 15%;text-align: center;">
                           
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                            <img [src]="this.parent.BackendServiceUrl + this.CurrentInvoice.Details.Agent?.Signature" style="height: auto;
                            width: auto;
                            max-width: 100%;
                            max-height: 100px;"/>
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 25%;text-align: right;padding-right: 10px;">
                          
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: auto;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: bold;height: auto;float: left;min-height: 30px;width: 50%;text-align: left;padding-left: 5px;">
                            {{this.CurrentInvoice.Details?.ShippingDetails?.ShippingDetailsTextUI}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: auto;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 10px;font-weight: 500;height: auto;float: left;min-height: 30px;width: 50%;text-align: left;padding-left: 5px;">
                            {{this.CurrentInvoice.Details.Observations}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;background: #f6f6f6;">
                      <tbody>
                        <tr>
                          <td style="padding:5px;">
                            <tr style="float: left;width: 100%;height: auto;">
                              <td style="line-height: 12px;font-size: 12px;font-weight: 500;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                                {{this.CurrentInvoice.Company.Name}}
                              </td>
                            </tr>
                            <tr style="float: left;width: 100%;height: auto;">
                              <td style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                                {{ 'Telephone' | translate }}: {{this.CurrentInvoice.Details.Agent.Phone}}; Email: {{this.CurrentInvoice.Details.Agent.Email}}
                              </td>
                            </tr>
                            <tr style="float: left;width: 100%;height: auto;" *ngFor="let b of this.CurrentInvoice.Company.Banks">
                              <td *ngFor="let a of b.BankAccounts" style="line-height: 12px;font-size: 12px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                                {{ 'Partners.PartnerWindow.BankAccountNumber' | translate }} ({{a.Currency.Name}}) : {{a.AccountNumber}}
                              </td>
                            </tr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;" *ngIf="this.CurrentInvoice.Details.SignStampSubstituteRows.length > 0;">
                      <tbody>
                        <tr>
                          <td style="padding:5px;">
                            <tr style="float: left;width: 100%;height: auto;" *ngFor="let row of this.CurrentInvoice.Details.SignStampSubstituteRows">
                              <td style="line-height: 11px;font-size: 11px;height: auto;float: left;min-height: 12px;width: 100%;text-align: left;">
                                {{row}}
                              </td>
                            </tr>
                          </td>
                        </tr>
                      </tbody>
                    </table>
              
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="float: left;width: 100%;height: auto;">
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 7.5%;text-align: center;">
                            
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 30%;text-align: left;">
                        
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 12.5%;text-align: right;">
                           
                          </td>
                          <td style="line-height: 12px;font-size: 12px;padding-top: 19px;font-weight: 500;height: auto;float: left;min-height: 50px;width: 50%;text-align: right;padding-right: 10px;">
                            {{'DocumentGeneratedBySoftware' | translate}}: <a href="https://www.foxcloud.ro" style="color: #254a91;">www.foxcloud.ro</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
         </div>
       
    </div>

      <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowCashCollectionContainer">
        <div class="PopUpCloseContainer" (click)="ShowCashCollectionContainer = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p>{{ 'NewCashCollection' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">
            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'CashCollectionType' | translate }}</mat-label>
                <mat-select name="CashCollectionType" [(ngModel)]="currentCashCollettion.Type" [compareWith]="compareFn">
                  <mat-option *ngFor="let type of this.CashCollectTypes;" [value]="type">
                    {{type.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Currency' | translate }}</mat-label>
                <mat-select name="Currency" [(ngModel)]="currentCashCollettion.Currency" [compareWith]="compareFn">
                  <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                <mat-select name="AccountNumber" [(ngModel)]="currentCashCollettion.BankAccount" [compareWith]="compareFn">
                  <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                    {{b.DisplayValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentCashCollettion.Currency.ExchangeRate > 0;">
                <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
                <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Currency.ExchangeRate">
                <mat-icon matSuffix>calculate</mat-icon>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                <mat-select name="DecimalPercision" [(ngModel)]="currentCashCollettion.Currency.DecimalPrecision" [compareWith]="compareFn">
                  <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                    {{d.Meaning}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

          <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
            <mat-label>{{ 'CollectionDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentCashCollettion.CollectionDate">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'CollectionValue' | translate }}* [{{this.currentCashCollettion.Currency.Name}}]</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Value" (change)="VerifyPriceModel(this.currentCashCollettion.Value);">
            <mat-icon matSuffix>monetization_on</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'CollectionExternalID' | translate }}</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.CollectionExternalID">
            <mat-icon matSuffix>qr_code_2</mat-icon>
          </mat-form-field>

          <p class="CashCollectRemainingInfo" *ngIf="this.CollectionRemainingValue >= 0;">{{'RemainingToCashCollect' | translate}}: {{this.CollectionRemainingValue}} {{this.currentCashCollettion.Currency.Name}}</p>
          <p class="CashCollectRemainingInfo" *ngIf="this.CollectionRemainingValue < 0;">{{'OverCashCollected' | translate}}: {{this.CollectionRemainingValue}} {{this.currentCashCollettion.Currency.Name}}</p>
         </div>

         <div class="PopUpCommands" *ngIf="this.IsCollectiveCollection == false;">
          <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddCashCollection();ShowCashCollectionContainer = false;">{{'Collect' | translate}}</button>
        </div>
        <div class="PopUpCommands" *ngIf="this.IsCollectiveCollection == true;">
          <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddCollectiveCashCollection();ShowCashCollectionContainer = false;">{{'Collect' | translate}}</button>
        </div>
      </div>

      <div class="animated fadeInDown CashCollectionContainer" style="top:15%!important;" *ngIf="ShowSuggestedCashCollectionModifier">
        <div class="PopUpCloseContainer" (click)="ShowSuggestedCashCollectionModifier = false;">
          <i class="material-icons">close</i>
        </div>

        <div class="PopUpTitleContainer">
          <p *ngIf="this.currentCashCollettion.ID > 0;">{{ 'UpdateCashCollection' | translate }}</p>
          <p *ngIf="!this.currentCashCollettion.ID > 0;">{{ 'NewCashCollection' | translate }}</p>
         </div>

         <div class="PopUpBody" style="margin-top: 20px;">

            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                <mat-label>{{ 'AssociatedInvoice' | translate }}*</mat-label>
                <input *ngIf="!this.currentCashCollettion.InvoiceID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.DisplayValue" (click)="SearchInvoices(this.currentCashCollettion.DisplayValue);" (keyup)="SearchInvoices(this.currentCashCollettion.DisplayValue);">
                <input disabled="disabled" *ngIf="this.currentCashCollettion.InvoiceID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.DisplayValue">
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentCashCollettion.InvoiceID.length > 0;" (click)="this.currentCashCollettion.InvoiceID = '';this.currentCashCollettion.DisplayValue = '';DeallocateInvoiceFromCC();">close</mat-icon>
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentCashCollettion.InvoiceID.length > 0 && CCInvoices != null;" (click)="this.currentCashCollettion.DisplayValue = ''; CCInvoices = null; DeallocateInvoiceFromCC();">close</mat-icon>
            </mat-form-field>

            <div class="InvoiceSearchContainer" *ngIf="CCInvoices != null;">
                <div class="InvoiceSearchResult" *ngFor="let i of this.CCInvoices; let j=index;" (click)="SelectInvoiceForCashCollectionSearch(i);">
                   <div class="InvoiceSearchResultCol">
                    {{i.AccountingNumber.DisplayValue}}
                   </div>
                   <div class="InvoiceSearchResultCol" style="width: 40%;">
                    {{i.Client.Name}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{i.EventRegisterUIDate}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{i.Total.TotalQtyPriceVAT}} {{i.Currency.Name}}
                   </div>
                </div>
           </div>

            <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'CashCollectionType' | translate }}</mat-label>
                <mat-select name="CashCollectionType" [(ngModel)]="currentCashCollettion.Type" [compareWith]="compareFn">
                  <mat-option *ngFor="let type of this.CashCollectTypes;" [value]="type">
                    {{type.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Currency' | translate }}</mat-label>
                <mat-select name="Currency" [(ngModel)]="currentCashCollettion.Currency" [compareWith]="compareFn">
                  <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
                <mat-select name="AccountNumber" [(ngModel)]="currentCashCollettion.BankAccount" [compareWith]="compareFn">
                  <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                    {{b.DisplayValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentCashCollettion.Currency.ExchangeRate > 0;">
                <mat-label>{{ 'Receptions.ExchangeRate' | translate }}</mat-label>
                <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Currency.ExchangeRate">
                <mat-icon matSuffix>calculate</mat-icon>
              </mat-form-field>

              <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                <mat-label>{{ 'Receptions.DecimalPercision' | translate }}</mat-label>
                <mat-select name="DecimalPercision" [(ngModel)]="currentCashCollettion.Currency.DecimalPrecision" [compareWith]="compareFn">
                  <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                    {{d.Meaning}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

          <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
            <mat-label>{{ 'CollectionDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentCashCollettion.CollectionDate">
            <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
            <mat-datepicker #dp3></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'CollectionValue' | translate }}* [{{this.currentCashCollettion.Currency.Name}}]</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.Value" (change)="VerifyPriceModel(this.currentCashCollettion.Value);">
            <mat-icon matSuffix>monetization_on</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
            <mat-label>{{ 'CollectionExternalID' | translate }}</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentCashCollettion.CollectionExternalID">
            <mat-icon matSuffix>qr_code_2</mat-icon>
          </mat-form-field>
         </div>

         <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" class="PopGeneralCommandButton" (click)="ShowSuggestedCashCollectionModifier = false;UpdateCashCollection(this.currentCashCollettion);">
              <span>{{'UpdateCashCollection' | translate}}</span>
        </button>
        </div>
      </div>

    <div class="MainTitleBar">
        <p class="SectionHalfTitle" style="margin-top: 0%;">{{ 'Invoices' | translate }}</p>
        <div class="SectionHalfTitle SectionHalfTitleRight">
            <button style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary" (click)="this.parent.OpenNewAdvanceInvoice('dashboard/sales/invoice');"><i class="material-icons">add</i> {{'AdvanceInvoice' | translate}}</button>
            <button style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary" (click)="this.parent.OpenNewProformaInvoice('dashboard/sales/invoice');"><i class="material-icons">add</i> {{'Proforma' | translate}}</button>
            <button style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary" (click)="this.parent.OpenNewInvoice('dashboard/sales/invoice');"><i class="material-icons">add</i> {{'Invoice' | translate}}</button>
            <button (click)="ExportAllOrPageOnlyQuestion = true;" style="padding-left: 10px;background:#32aa3a;margin-right: 10px;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'Export' | translate}}</button>
            <button (click)="GenerateSAGAExport();" style="padding-left: 10px;background:#32aa3a;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'Export' | translate}} SAGA</button>
          </div>
    </div>

    <div class="overlay" *ngIf="ShowPreAskClientBalanceAllocation || ShowANAFRedirectionNotification || ShowEFacturaBulkQuestion || ShowCombineInOneInvoiceQuestion || ShowEFacturaSendMenu || ShowRecallibrateProfitsSTPFinal || ShowSellthroughPartnerProfitsRecallibration || ShowForceStatusContainer || ShowObservationDetailContainer || ShowExportBulkQuestion || ShowDeleteShippingDetailsContainer || ExportAllOrPageOnlyQuestion || ShowMustSelectSinglePartnerError || ShowOriginalCurrencyError || ShowShippingDetailsContainer || ShowDeleteBoxQuestion || ShowAutoPrintBulkQuestion || ShowDeleteInvoiceRelatedCashCollections || ShowDeactivateDocumentQuestion || ShowReactivateDocumentQuestion || ShowDeleteInvoiceQuestion || SellThroughPartnerSelectSellingPartnerPart3 || SellThroughPartnerSelectSellingPartnerPart2 || SellThroughPartnerSelectSellingPartner || SingleCurrencyOnCollectivePaymentError || ShowDeactivatedDocumentsOnSelectAllQuestion || ShowAdvancePaymentInvoiceToFinancialInvoiceQuestion || ShowProformaInvoiceConvertorQuestion || ShowSuggestionCashCollectionsContainer || ShowCashCollectionContainer || showEditPartnerPopUp || showInvoiceVisualizer;" (click)="showEditPartnerPopUp = false; showInvoiceVisualizer = false;"></div>

    <div class="MainTitleBar" style="overflow: hidden;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetInvoicesFiltered();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer" style="margin-top: -4px;">
            <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetInvoicesFiltered();">
              <mat-icon>filter_alt</mat-icon>
            </button>
        </div>
      
      </div>

      <div *ngIf="showEditPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
        <div class="PopUpCloseContainer" (click)="showEditPartnerPopUp = false;">
          <i class="material-icons">close</i>
        </div>
        <div class="PopUpTitleContainer">
         <p>{{ 'Partners.EditPartner' | translate }}</p>
        </div>
    
        <div class="PopUpBody">
    
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
    
          <form [formGroup]="currentPartner">
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
              <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
              <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.currentPartner, false);" *ngIf="this.currentPartner.controls['VAT'].value != null && this.currentPartner.controls['VAT'].value.length;">cloud_download</i>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
              <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
            </mat-form-field>
    
            <div class="PopUpBodySemiTextBox">
              <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
            </div>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
                <mat-select name="country" [compareWith]="compareFn" formControlName="Country" required>
                  <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="City" required>
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}</p>
    
            <div class="PopUpBodySemiTextBox">
              <mat-form-field>
                <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
                <mat-select name="bank" [compareWith]="compareFn" formControlName="Bank">
                  <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                    {{b.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
            </mat-form-field>
    
            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Email' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
            </mat-form-field>
    
            <mat-form-field class="example-full-width PopUpBodySemiTextBox">
              <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
              <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
            </mat-form-field>
          </form>
    
        </div>
    
        <div class="PopUpCommands">
          <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="UpdatePartner();">{{'UpdatePartner' | translate}}</button>
        </div>
      </div>

    <div class="MainTitleBar" style="overflow: unset;" *ngIf="InvoicePrecision != null;">
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
            <i class="material-icons">filter_alt</i>
            <span>{{'Filter' | translate}}</span>
        </div>

        <div class="FilterButton noselect" style="margin-left: 10px;" *ngIf="AnyChecked" (click)="ShowAutoPrintBulkQuestion = true;">
          <i class="material-icons">print</i>
        </div>

        <div class="FilterButton noselect" style="margin-left: 10px;" *ngIf="AnyChecked" (click)="ShowExportBulkQuestion = true;">
          <i class="material-icons">file_copy</i>
        </div>

        <div class="FilterButton noselect" style="margin-left: 10px;" *ngIf="AnyChecked" (click)="ShowCombineInOneInvoiceQuestion = true;">
          <i class="material-icons">merge</i>
        </div>

        <div class="FilterButton noselect BulkEFacturaButton" style="margin-left: 10px;" *ngIf="AnyChecked" (click)="ShowEFacturaBulkQuestion = true;">
          <i class="material-icons">play_arrow</i>
          <span>{{'APIEFactura' | translate}}</span>
        </div>
    
        <div class="ActiveFiltersContainer">
          <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
            {{a.Name}}
            <i class="material-icons">close</i>
          </div>
        </div>
    
        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>
    
            <div class="FilterContainerBody">
    
                <div class="PopUpBodyRow">
                </div>
    
                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{ 'Receptions.Administration' | translate }}</mat-label>
                        <mat-select name="Administration" [(ngModel)]="Filter.Administration">
                          <mat-option *ngFor="let a of this.Administrations;" [value]="a" (click)="AddActiveFilter(a.Name, 'Administration');">
                            {{a.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                
                <div class="PopUpBodyOneThirddContainer">
                <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                  <mat-label>{{ 'Receptions.Series' | translate }}</mat-label>
                   <mat-select name="Series" [(ngModel)]="Filter.AccountingSeries">
                    <mat-option *ngFor="let a of this.AccountingSeries;" [value]="a" (click)="AddActiveFilter(a.Series, 'Series');">
                       {{a.Series}}
                     </mat-option>
                   </mat-select>
                  </mat-form-field>
                </div>
                 
                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{ 'DocStatus' | translate }}</mat-label>
                        <mat-select name="Series" [(ngModel)]="Filter.DocumentStatus">
                          <mat-option *ngFor="let d of this.DocumentStatuses;" [value]="d" (click)="AddActiveFilter(d.Name, 'DocStatus');">
                            {{d.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
                
                <div class="PopUpBodyTwoThirdsContainer">
                    <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                        <mat-label>{{ 'SearchProductInvoicesFilter' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'SearchProductInvoicesFilter' | translate }}" autocomplete="off" [(ngModel)]="Filter.Product" (change)="AddActiveFilter('PN: ' + Filter.Product, 'Product');">
                      </mat-form-field>
                </div>

                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{'Currency' | translate}}</mat-label>
                        <mat-select name="Currency" [(ngModel)]="Filter.Currency">
                          <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="AddActiveFilter(c.Name, 'Currency');">
                            {{c.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
    
                <div class="PopUpBodyTwoThirdsContainer">
                    <mat-form-field appearance="outline" style="width: 100%;padding: 0;" (click)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);">
                        <mat-label>{{ 'SearchClient' | translate }}*</mat-label>
                        <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.partner = Partners[0];resultsLength = 0;this.searchTerm = Partners[0].Name;this.Filter.Partner = Partners[0];AddActiveFilter(Partners[0].Name, 'Partner');GetInvoicesFiltered();">
                        <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                        <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.partner = null; this.Filter.Partner = null;">close</i>
                      </mat-form-field>
    
                      <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                        <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm=p.Name;this.Filter.Partner = p;AddActiveFilter(p.Name, 'Partner');">
                            <p class="SearchResultTitle DottedRow">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length;">{{p.VAT}}</span></p>
                        </div>
                      </div>
                </div>

                <div class="PopUpBodyOneThirddContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{'ClientCountry' | translate}}</mat-label>
                        <mat-select name="Country" [(ngModel)]="Filter.Country">
                          <mat-option *ngFor="let c of this.Countries;" [value]="c" (click)="AddActiveFilter(c.Name, 'Country');">
                            {{c.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>

                <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                    <mat-label>{{'TranzactionType' | translate}}</mat-label>
                    <mat-select name="TranzactionType" [(ngModel)]="Filter.TranzactionType">
                      <mat-option *ngFor="let d of this.TranzactionTypes;" [value]="d" (click)="AddActiveFilter(d.Name, 'TranzactionType');">
                        {{d.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

              <div class="PopUpBodyOneThirddContainer">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                      <mat-label>{{'InvoiceDocType' | translate}}</mat-label>
                      <mat-select name="Country" [(ngModel)]="Filter.InvoiceDocType">
                        <mat-option *ngFor="let d of this.DocTypes;" [value]="d" (click)="AddActiveFilter(d.Meaning, 'InvoiceDocType');">
                          {{d.Meaning}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
              </div>

                <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                    <mat-label>{{'ShippingCompany' | translate}}</mat-label>
                    <mat-select name="Country" [(ngModel)]="Filter.ShippingCompany">
                      <mat-option *ngFor="let s of this.ShippingCompanies;" [value]="s" (click)="AddActiveFilter(s.Name, 'ShippingCompany');">
                        {{s.Name}}
                        <img *ngIf="s.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + s.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="PopUpBodyOneThirddContainer">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                    <mat-label>{{'EFacturaStatus' | translate}}</mat-label>
                    <mat-select name="EFacturaStatus" [(ngModel)]="Filter.EFacturaStatus">
                      <mat-option *ngFor="let d of this.EFacturaStatuses;" [value]="d" (click)="AddActiveFilter('[EFactura]' + d.Name, 'EFacturaStatus');">
                        {{d.Name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
            </div>
            
            <div class="FilterCommands">
                <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetInvoicesFiltered();">{{ 'FilterInvoices' | translate }}</button>
            </div>
        </div>

        <div class="TotalDocCountContainer">
          <span style="float: right;">{{this.Invoices?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Invoices' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
          <div class="PageSizeContainer">
            <mat-form-field appearance="outline" class="PageSizeTextBox">
              <mat-label>{{ 'PageSize' | translate }}*</mat-label>
              <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetInvoicesFiltered(1);">
            </mat-form-field>
          </div>
        </div>

        <div class="TotalDocCountContainer">
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetInvoicesFiltered(this.Filter.Pager.PageIndex - 1);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetInvoicesFiltered(this.Filter.Pager.PageIndex + 1);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>
        </div>
    </div>

    <div class="MainTitleBar" style="overflow: unset;" *ngIf="this.Filter?.Partner?.PartnerBalances?.length > 0;">
      <div class="PartnerBalanceRow" *ngFor="let balance of this.Filter.Partner.PartnerBalances; let b=index;">
         <span>{{'ClientBalance' | translate}}: {{balance.Total.UITotalQtyPriceVAT.Integer}} {{balance.Total.UITotalQtyPriceVAT.Decimals}} {{balance.Total.Currency.Name}}</span>
         <div class="ClientBalanceAllocation" (click)="PreAskClientBalanceAllocation();">{{'AllocateBalance' | translate}}</div>
      </div>
    </div>

    <div class="MainBody">

        <div class="ReceptionProductsContainer">
          
            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
                <div class="ReceptionProductsCol" style="width: 2.5%;">
                  <mat-checkbox class="tableColCheckBox" [(ngModel)]="AllSelected" (change)="SelectAll();"></mat-checkbox>
                </div>
                <div class="ReceptionProductsCol" style="width: 2.5%;">
                  e
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                    {{ 'Receptions.Table.Nr' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                  {{ 'ShippingCompany' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 20%;padding-left: 20px;text-align: left;cursor: pointer;" (click)="JuggleSorting();">
                  {{ 'Client' | translate }}
                  <i class="material-icons tableHeadderSortingIcon" *ngIf="this.Filter.SortingOrder?.ID == 1;">keyboard_arrow_down</i>
                  <i class="material-icons tableHeadderSortingIcon" *ngIf="this.Filter.SortingOrder?.ID == 2;">keyboard_arrow_up</i>
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{ 'CreatingDate' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'DueDate' | translate }}
                  </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{ 'SubTotal' | translate }} 
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{ 'VATTotal' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    Total
                </div>
                <div class="ReceptionProductsCol" style="width: 5%;">
                    {{ 'Currency' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{ 'Observations' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                    {{ 'Status' | translate }}
                  </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{ 'Actions' | translate }}
                </div>
            </div>
    
            <div class="ReceptionProductsRow TotalRow" *ngIf="loading">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
            </div>
            <div *ngIf="!loading">
                <div [ngClass]="{'deactivatedReception': i.DocumentStatus.ID == -1, 'ObservationPadding': i.Details.Observations?.length > 0 }" class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let i of this.Invoices; let j=index;">
                    <div class="ReceptionProductsCol" style="width: 2.5%;">
                       <mat-checkbox class="tableColCheckBox" [(ngModel)]="i.IsSelected" (change)="CheckIfAnyChecked();"></mat-checkbox>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 2.5%;">
                      <span *ngIf="i.Details?.EFacturaDetails?.Status?.ID > -2;" class="EFacturaStatusDot" matTooltip="--- {{'EFacturaStatus' | translate}}: {{i.Details?.EFacturaDetails?.Status?.Name}} --- {{i.Details?.EFacturaDetails?.ErrorMessage}}" matTooltipClass='neutral-tool-tip' [ngClass]="{'EFacturaErrorStatus': i.Details.EFacturaDetails.Status.ID == -1, 'EFacturaValidatingStatus': i.Details.EFacturaDetails.Status.ID == 1, 'EFacturaSuccessStatus': i.Details.EFacturaDetails.Status.ID == 2}"></span>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        <p class="ReceptionTitleP">
                          <span (click)="VizualizeDocument(i.ID);" class="ReceptionTitleSpan">{{i.AccountingNumber.DisplayValue}}</span>
                        </p>
                        <p *ngIf="i.IsStorno && loadingInvoiceID != i.ID;" class="stornoRow">storno</p>
                        <p *ngIf="i.DocType.ID == 2;" class="stornoRow">{{'AdvanceInvoice' | translate}}</p>
                        <p *ngIf="i.DocType.ID == 1;" style="color: #f60;font-size: 12px; font-weight: bold;" class="stornoRow">{{'Proforma' | translate}}</p>
                        <mat-progress-bar mode="buffer" *ngIf="loadingDocumentInformation && loadingInvoiceID == i.ID;" class="loadingDocumentInformation"></mat-progress-bar>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;" (click)="this.CurrentInvoice = i;GetShippingDetails(this.CurrentInvoice.Details.ID, this.CurrentInvoice.Client.ID);">
                        <p>
                          <img style="cursor: pointer;" *ngIf="i.Details?.ShippingDetails?.ShippingCompany?.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + i.Details.ShippingDetails.ShippingCompany.ImagePath" class="ShippingDetailsContainerShippingCompanyImage" />
                        </p>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 20%;font-weight: 500;">
                        <p style="padding-right: 20px;padding-left: 20px;text-align: left;padding-bottom: 0px;">
                          <span class="ColClientName">{{i.Client.Name}}</span>
                          <i class="material-icons EFacturaLock" *ngIf="i.Details?.EFacturaDetails?.Status?.ID > 0;" matTooltip="{{'LockedByEFactura' | translate}}" matTooltipClass='neutral-tool-tip'>lock_outline</i>
                        </p>
                        <i class="material-icons OverduePaymentDaysAlert" *ngIf="i.OverduePaymentDays > 0 && i.DocumentStatus.ID == 5;" matTooltip="{{i.OverduePaymentDays}} {{'DaysLate' | translate}}" matTooltipClass='neutral-tool-tip'>watch_later</i>
                        <div *ngIf="i.Client?.FinancialData?.Status != null;" class="FinancialStatus" matTooltip="{{i.Client?.FinancialData.Status.SituationDescription}}" matTooltipClass='neutral-tool-tip'>
                          <span *ngIf="i.Client?.FinancialData?.Status.ID != -3 && i.Client?.FinancialData?.Status.ID != -2;">
                            {{i.Client?.FinancialData?.Status?.Name}}
                          </span>
                          <span *ngIf="i.Client?.FinancialData?.Status.ID == -3;" style="color: #fd4f57;">
                            {{i.Client?.FinancialData?.Status?.Name}}
                          </span>
                          <span *ngIf="i.Client?.FinancialData?.Status.ID == -2;" style="color: #f60;">
                            {{i.Client?.FinancialData?.Status?.Name}}
                          </span>
                          <i style="color: #fd4f57;" *ngIf="i.Client?.FinancialData?.Status.ID == -3;" class="material-icons">block</i>
                          <i style="color: #f60;" *ngIf="i.Client?.FinancialData?.Status.ID == -2;" class="material-icons">info</i>
                          <i style="color: #254a91;" *ngIf="i.Client?.FinancialData?.Status.ID == -1;" class="material-icons">check</i>
                          <i style="color: #32aa3a;" class="material-icons" *ngIf="i.Client?.FinancialData?.Status.ID == 1;" >verified</i>
                        </div>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 7.5%;">
                        {{i.EventRegisterUIDate}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 7.5%;">
                        {{i.PaymentDueDateUI}}
                        <div *ngIf="i.DocumentStatus.ID == 5;" class="EmailNotificationsCountSpan">
                          {{i.Details.EmailNotificationsCount}} {{'SendEmailNotifications' | translate}}
                        </div>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 7.5%;">
                        <p>{{i.Total.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{i.Total.UITotalQtyPriceNOVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 7.5%;">
                        <p>{{i.Total.UITotalVAT.Integer}} <span class="DecimalsSpan">{{i.Total.UITotalVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 7.5%;">
                        <p>{{i.Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{i.Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                        <div class="CashCollectionsRemainingValues" *ngIf="i.Details.CashCollectionRemainingValue != i.Total?.TotalQtyPriceVAT && i.Details.CashCollectionRemainingValue > 0;">
                          {{'RemainingToCashCollect' | translate}}: {{i.Details.CashCollectionRemainingValue}} {{i.InitialSavedCurrency.Name}}
                        </div>
                        <div class="CashCollectionsOverValues" *ngIf="i.Details.CashCollectionRemainingValue != i.Total?.TotalQtyPriceVAT && i.Details.CashCollectionRemainingValue < 0;">
                          {{'OverCashCollected' | translate}}: {{i.Details.CashCollectionSurplusValue}} {{i.InitialSavedCurrency.Name}}
                        </div>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 5%;">
                        <p class="CurrencySpecialRow">{{i.Currency.Name}}</p>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 7.5%;cursor: pointer;" (dblclick)="CurrentInvoice = i;ShowObservationDetailContainer = true;">
                        <p>{{i.Details.Observations}}</p>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 7.5%;">
                        <p>
                          <span [ngClass]="{'CancelledStatus': i.DocumentStatus.ID == -1, 'CollectedStatus': i.DocumentStatus.ID == 1,'PartiallyCollected': i.DocumentStatus.ID == 2,'SurplusCollected': i.DocumentStatus.ID == 3, 'CreatedStatus': i.DocumentStatus.ID == 4, 'Overdue': i.DocumentStatus.ID == 5}">{{i.DocumentStatus.Name}}</span>
                        </p>
                        <div *ngIf="i.DocumentStatus.ID == 5;" class="OverDueDaysNote">
                          {{i.OverduePaymentDays}} {{'DaysLate' | translate}}
                        </div>
                        <div *ngIf="i.Details.ForceDocumentClosing == true;" class="OverDueDaysNote">
                          {{'ForcedDocumentClose' | translate}}
                        </div>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 7.5%;">
                        <i class="material-icons actionsArrow" [matMenuTriggerFor]="menu" (click)="GetInvoiceDataToGalleryList(i.ID, false, false);">keyboard_arrow_down</i>
                           <mat-menu #menu="matMenu">
                            <button mat-menu-item class="ReceptionMenuButton" (click)="VizualizeDocument(i.ID);">
                                <i class="material-icons">image_search</i>
                                <span>{{ 'Receptions.Table.ButtonMenu.Visualize' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1;" (click)="ViewInvoice(i);">
                              <i class="material-icons">mode_edit</i>
                              <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="this.CurrentInvoice = i; this.InitializeEmailBulkSendContainer();">
                              <i class="material-icons" style="color: #0082e6;">notifications_on</i>
                              <span>{{ 'NotifyClient' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1;" (click)="GenerateInvoicesDeliveryNote(i);">
                              <i class="material-icons">sticky_note_2</i>
                              <span>{{ 'DeliveryNote' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1 && i.DocType.ID == 1 && i.IsStorno == false;" (click)="ConvertProformaToInvoiceQuestion(i);">
                              <i class="material-icons">domain_verification</i>
                              <span>{{ 'ConvertToInvoice' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1 && i.DocType.ID == 2 && i.IsStorno == false;" (click)="ConvertAdvancePaymentInvoiceToFinancialInvoiceQuestion(i);">
                              <i class="material-icons">domain_verification</i>
                              <span>{{ 'ConvertFromAdvanceToInvoice' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="GetInvoiceCashCollections(i.Details.ID);">
                              <i class="material-icons">playlist_add_check</i>
                              <span>{{ 'CashCollections' | translate }}</span>
                          </button>
                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1 && !i.IsSelected;" (click)="InitializeNewCashCollection(i);">
                              <i class="material-icons">monetization_on</i>
                              <span>{{ 'Collect' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1 && i.IsSelected;" (click)="AlertDeactivatedDocumentsOnSelectAll(i);">
                                <i class="material-icons">monetization_on</i>
                                <span>{{ 'Collect' | translate }}</span>
                            </button>

                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1 && i.Details.ForceDocumentClosing != true;" (click)="ShowForceStatusContainer = true;this.CurrentInvoice = i;">
                              <i class="material-icons">incomplete_circle</i>
                              <span>{{ 'ForceDocumentClosing' | translate }}</span>
                            </button>

                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1 && i.Details.ForceDocumentClosing == true;" (click)="ShowForceStatusContainer = true;this.CurrentInvoice = i;">
                              <i class="material-icons">incomplete_circle</i>
                              <span>{{ 'DeForceDocumentClosing' | translate }}</span>
                            </button>

                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1 && i.IsStorno != true && i.DocType.ID != 1;" (click)="GenerateNewInvoice(i, true, false);">
                                <i class="material-icons">settings_backup_restore</i>
                                <span>{{ 'Receptions.Table.ButtonMenu.stornate' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID != -1;" (click)="ShowDeactivateDocumentQuestion = true; this.CurrentInvoice = i;">
                                <i class="material-icons">close</i>
                                <span>{{ 'Receptions.Table.ButtonMenu.cancelDoc' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" *ngIf="i.DocumentStatus.ID == -1;" (click)="ShowReactivateDocumentQuestion = true; this.CurrentInvoice = i;">
                                <i class="material-icons">verified</i>
                                <span>{{ 'Receptions.Table.ButtonMenu.reactivateDoc' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="GenerateNewInvoice(i, false, true);">
                                <i class="material-icons">content_copy</i>
                                <span>{{ 'Copy' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="ShowDeleteInvoiceQuestion = true;this.CurrentInvoice = i;">
                                <i class="material-icons">delete_forever</i>
                                <span>{{ 'Receptions.Table.ButtonMenu.delete' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="initializePartnerFormFromObject(i.Client);">
                                <i class="material-icons">person_search</i>
                                <span>{{ 'ViewClient' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="GetSalesDocumentsTraces(i);">
                              <i class="material-icons">settings_backup_restore</i>
                              <span>{{ 'SellthroughPartnerProfitsRecallibration' | translate }}</span>
                            </button>
                            <button *ngIf="i.DocType?.ID == 0 && i.DocumentStatus.ID != -1;" matTooltip="{{ 'GenerateReceptionFromInvoiceDescription' | translate }}" matTooltipClass='neutral-tool-tip' mat-menu-item class="ReceptionMenuButton" (click)="GenerateReceptionFromInvoice(i);">
                              <i class="material-icons actionIcon">play_arrow</i>
                              <span>{{ 'GenerateReceptionFromInvoice' | translate }}</span>
                            </button>
                            <button *ngIf="i.DocType?.ID == 0 && i.DocumentStatus.ID != -1;" matTooltip="{{ 'SellThroughAPartnerDesc' | translate }}" matTooltipClass='neutral-tool-tip' mat-menu-item class="ReceptionMenuButton" (click)="OpenSellThroughPartnerSelectSellingPartner(i);">
                              <i class="material-icons actionIcon">play_arrow</i>
                              <span>{{ 'SellThroughAPartner' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="this.CurrentInvoice = i;GetShippingDetails(this.CurrentInvoice.Details.ID, this.CurrentInvoice.Client.ID);">
                              <i class="material-icons">local_shipping</i>
                              <span>{{ 'ShippingDetails' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="AutoPrintDocument(i);">
                              <i class="material-icons">print</i>
                              <span>{{ 'AutoPrint' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="OpenResetEFactura(i);" *ngIf="i.Details?.EFacturaDetails?.Status?.ID > -2;">
                              <i class="material-icons">lock_reset</i>
                              <span>{{ 'ResetEFacturaStatus' | translate }}</span>
                            </button>
                            <button mat-menu-item class="ReceptionMenuButton" (click)="UpdateDocumentTransportationCost(i);">
                              <i class="material-icons">local_shipping</i>
                              <span>{{ 'CheckTransportCosts' | translate }}</span>
                            </button>
                           </mat-menu>
                    </div>
          </div>
            </div>
    
            <div *ngIf="this.Invoices != null && this.Invoices.length > 0 && !loading;">
                <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngFor="let Total of this.Totals; let i=index;">
                    <div class="ReceptionProductsCol" style="width: 32.5%;">
                      <mat-slide-toggle [disabled]="Filter.DisplayAllPagesTotals == true" (change)="GetInvoicesFiltered();" *ngIf="i == 0;" [(ngModel)]="Filter.ExchangeToTargetCurrency">{{'DisplaySingleCurrency' | translate}}</mat-slide-toggle>
                    </div>
                    <div class="ReceptionProductsCol" style="width: 7.5%;text-align: left;padding-left: 1%;">
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                        Total:
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                        <p>{{Total.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceNOVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                        <p>{{Total.UITotalVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                        <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                    </div>
                    <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                        {{Total.Currency?.Name}}
                    </div>
                    <div class="ReceptionProductsCol" style="width: 25%;">
                        
                    </div>
            </div>
            </div>

            <div *ngIf="this.Invoices != null && this.Invoices.length > 0 && !loading;">
              <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow">
                  <div class="ReceptionProductsCol" style="width: 32.5%;">
                    <mat-slide-toggle (change)="GetInvoicesFiltered();" [(ngModel)]="Filter.DisplayAllPagesTotals">{{'DisplayAllPagesTotals' | translate}}</mat-slide-toggle>
                  </div>
                  <div class="ReceptionProductsCol" style="width: 7.5%;text-align: left;padding-left: 1%;">
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                     
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                      
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                      
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 7.5%;">
                     
                  </div>
                  <div class="ReceptionProductsCol totalCol" style="width: 5%;">
                      
                  </div>
                  <div class="ReceptionProductsCol" style="width: 25%;">
                      
                  </div>
          </div>
          </div>
    
        <div class="ReceptionProductsRow ReceptionProductsRowHover TotalRow" *ngIf="!loading && Invoices.length > 0;">
          <div class="ReceptionProductsCol" style="width: 10%;">
    
          </div>
          <div class="ReceptionProductsCol" style="width: 20%;">
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
            <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetInvoicesFiltered(this.Filter.Pager.PageIndex - 1);">
              <i class="material-icons">chevron_left</i>
            </button>
    
            <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;cursor: not-allowed;">
              <i class="material-icons">chevron_left</i>
            </button>
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
            {{this.Filter.Pager.PageIndex}} / {{this.Filter.Pager.Pages}}
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
            <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetInvoicesFiltered(this.Filter.Pager.PageIndex + 1);">
              <i class="material-icons">chevron_right</i>
            </button>
    
            <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;cursor: not-allowed;">
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
              
          </div>
          <div class="ReceptionProductsCol totalCol" style="width: 10%;">
              
          </div>
          <div class="ReceptionProductsCol" style="width: 10%;">
              
          </div>
      </div>
    
        </div>
    
    </div>

</div>
